export const LANGS = [
  { code: "en", label: "EN" },
  { code: "hi", label: "हिंदी" },
  { code: "mr", label: "मराठी" },
];

export const translations = {
  /* ------------------------------ ENGLISH ------------------------------ */
  en: {
    nav: {
      about: "About",
      lifecycle: "Services",
      brands: "Brands",
      industries: "Industries",
      contact: "Contact",
      cta: "Request a Quote",
    },
    hero: {
      eyebrow: "Precision Workholding · Dombivli MIDC, India",
      titleLines: ["HOLD EVERY", "MICRON.", "EVERY CYCLE."],
      sub: "Sales, presales engineering and post-sales support for high-precision workholding, clamping systems and tooling — trusted for over a decade by India's aerospace, defence and die & mould manufacturers.",
      ctaPrimary: "Request a Quote",
      ctaSecondary: "Explore Principals",
      badgeLabel: "Years of application engineering trust",
      chips: ["±0.002 mm repeatability", "Zero-distortion clamping"],
      scroll: "Scroll",
    },
    marquee: [
      "Zero-Point Clamping",
      "Electro-Permanent Magnetic Chucks",
      "5-Axis Vices",
      "Quick-Change Collet Chucks",
      "EDM Tooling",
      "Adaptive Workholding",
    ],
    about: {
      eyebrow: "Who We Are",
      title: "Application engineers at the machine — not just at the desk.",
      p1: "Operating from Plot RH 158, MIDC Dombivli East, Teknik Enterprises represents four world-class principals across magnetic, zero-point, mechanical and adaptive workholding. For over a decade we have helped Indian manufacturers clamp smarter — auditing components, calculating forces and standing behind every installation we commission.",
      p2: "We sell what we can prove. Every recommendation begins with a feasibility study on your component and ends with a machine making good parts.",
      stats: [
        { v: "10+", l: "Years of application trust" },
        { v: "4", l: "Global principal partnerships" },
        { v: "3", l: "Critical-precision industries" },
        { v: "360°", l: "Service lifecycle" },
      ],
    },
    lifecycle: {
      eyebrow: "360° Service Lifecycle",
      title: "From feasibility study to first good part.",
      sub: "One accountable partner, three stages of expertise.",
      steps: [
        {
          step: "01",
          title: "Presales Feasibility & Application Engineering",
          desc: "Deep component analysis, CAD model review, cutting-force calculation and fixture recommendation — before you spend a rupee.",
        },
        {
          step: "02",
          title: "Precision Product Sales & Supply",
          desc: "Genuine supply from world-class principals with calibration certificates, documentation and rapid delivery.",
        },
        {
          step: "03",
          title: "Post-Sales Integration & Training",
          desc: "On-site installation, zero-point alignment, operator safety and maintenance training — until your team runs it with full confidence.",
        },
      ],
    },
    brands: {
      eyebrow: "Our Principals",
      title: "Four world-class workholding houses. One accountable partner.",
      productsLabel: "Represented range",
      specsLabel: "Technical highlights",
      items: {
        rudra: {
          badge: "10+ Year Partnership",
          tagline: "Electro-permanent magnetic chucks & heavy-duty lifters",
          desc: "Electro-permanent magnetic workholding engineered for high-rigidity milling and surface grinding, plus heavy-duty lifters and coolant separation for the shop floor — from our longest-standing principal partnership of over ten years.",
        },
        erowa: {
          badge: "Swiss Precision Tooling",
          tagline: "Zero-point clamping, EDM tooling & automation",
          desc: "The complete EROWA Flexible Tooling System — standardized zero-point datums (MTS) that carry your part from milling to EDM to inspection with sub-micron repeatability, plus robot loading for lights-out production.",
        },
        spreitzer: {
          badge: "German Clamping Technology",
          tagline: "Vices for 5-axis, concentric & ALUMESS modular clamping",
          desc: "The full SPREITZER range — mechanical and hydraulic vices built for 5-axis access, self-centring concentric clamping, and the ALUMESS modular fixture system for measurement and machining.",
        },
      },
    },
    industries: {
      eyebrow: "Industries We Serve",
      title: "Where clamping failure is not an option.",
      items: [
        {
          id: "aerospace",
          name: "Aerospace Equipment Manufacturing",
          highlight: "Thin-wall component clamping with zero distortion",
          desc: "Low-stress magnetic and engineered fixtures hold thin ribs, casings and rings without distorting a single micron of geometry.",
          stat: "Zero-distortion fixturing",
        },
        {
          id: "defence",
          name: "Defence Equipment Manufacturing",
          highlight: "Heavy-duty clamping and magnetic systems",
          desc: "Fail-safe magnetic workholding and high-force clamping for armour steel, ordnance components and heavy plate.",
          stat: "Fail-safe magnetic holding",
        },
        {
          id: "diemould",
          name: "Die & Mould Industry",
          highlight: "Zero-point systems, 5-axis clamping, electrode machining",
          desc: "Palletized zero-point datums and electrode tooling move parts between milling, EDM and CMM — with repeatability guaranteed.",
          stat: "One datum, every machine",
        },
        {
          id: "precision",
          name: "Precision Machine Shops",
          highlight: "Versatile workholding for every lot size",
          desc: "From one-off jobbing to volume production — modular vices, chucks and mandrels that change over in seconds.",
          stat: "Fast changeover fixtures",
        },
      ],
    },
    form: {
      eyebrow: "Request a Quote",
      title: "Tell us what you need to hold.",
      sub: "Share your component and application — our engineers respond within one working day.",
      contactLabels: { phone: "Call us", email: "Email", visit: "Visit us" },
      labels: {
        name: "Full Name",
        company: "Company",
        email: "Email",
        phone: "Phone",
        brand: "Brand Interest",
        details: "Application Details",
      },
      placeholders: {
        name: "Your name",
        company: "Company name",
        email: "you@company.com",
        phone: "+91 ...",
        details: "e.g. thin-wall aerospace rib, 6061-T6 aluminium, on a 3-axis mill…",
      },
      selectOption: "Select…",
      brandOptions: ["Rudra Magnets", "EROWA", "SPREITZER", "Multiple / Not sure"],
      submit: "Submit Inquiry",
      submitting: "Submitting…",
      successTitle: "Inquiry received",
      successBody: "Our team will reach out within one working day.",
      errorTitle: "Something went wrong",
      errorBody: "Please try again, or email us at md@teknik.net.in.",
      address: "Plot No: RH 158, MIDC, Dombivli East, Maharashtra - 421203, India",
    },
    footer: {
      blurb: "High-precision workholding, clamping systems and tooling — sales, presales engineering and post-sales support.",
      principalsLabel: "Principals",
      servicesLabel: "Services",
      services: ["Sales", "Presales Engineering", "Post-sales Support"],
      rights: "All rights reserved.",
    },
  },

  /* ------------------------------ हिंदी ------------------------------ */
  hi: {
    nav: {
      about: "परिचय",
      lifecycle: "सेवाएँ",
      brands: "ब्रांड्स",
      industries: "इंडस्ट्रीज़",
      contact: "संपर्क",
      cta: "कोटेशन पाएँ",
    },
    hero: {
      eyebrow: "प्रेसिशन वर्कहोल्डिंग · डोंबिवली MIDC, भारत",
      titleLines: ["हर माइक्रोन", "पकड़ में —", "हर साइकल में।"],
      sub: "हाई-प्रेसिशन वर्कहोल्डिंग, क्लैंपिंग सिस्टम और टूलिंग के लिए सेल्स, प्रीसेल्स इंजीनियरिंग और पोस्ट-सेल्स सपोर्ट — एक दशक से भारत के एयरोस्पेस, रक्षा और डाई एंड मोल्ड उद्योग का भरोसा।",
      ctaPrimary: "कोटेशन पाएँ",
      ctaSecondary: "हमारे ब्रांड्स",
      badgeLabel: "वर्षों का एप्लिकेशन इंजीनियरिंग भरोसा",
      chips: ["±0.002 mm रिपीटेबिलिटी", "ज़ीरो-डिस्टॉर्शन क्लैंपिंग"],
      scroll: "स्क्रॉल",
    },
    marquee: [
      "ज़ीरो-पॉइंट क्लैंपिंग",
      "इलेक्ट्रो-परमानेंट मैग्नेटिक चक",
      "5-एक्सिस वाइस",
      "क्विक-चेंज कोलेट चक",
      "EDM टूलिंग",
      "एडाप्टिव वर्कहोल्डिंग",
    ],
    about: {
      eyebrow: "हम कौन हैं",
      title: "ऐप्लिकेशन इंजीनियर मशीन के पास — सिर्फ़ डेस्क पर नहीं।",
      p1: "प्लॉट RH 158, MIDC डोंबिवली ईस्ट से काम करते हुए, Teknik Enterprises चार विश्वस्तरीय प्रिंसिपल्स का प्रतिनिधित्व करता है — मैग्नेटिक, ज़ीरो-पॉइंट, मैकेनिकल और एडाप्टिव वर्कहोल्डिंग में। एक दशक से अधिक समय से हम भारतीय निर्माताओं को स्मार्ट क्लैंपिंग में मदद कर रहे हैं — कंपोनेंट ऑडिट, फ़ोर्स कैलकुलेशन और हर इंस्टॉलेशन के पीछे पूरा समर्थन।",
      p2: "हम वही बेचते हैं जिसे हम सिद्ध कर सकते हैं। हर सिफ़ारिश आपके कंपोनेंट पर फ़ीज़िबिलिटी स्टडी से शुरू होती है और अच्छे पार्ट्स बनाने वाली मशीन पर ख़त्म होती है।",
      stats: [
        { v: "10+", l: "एप्लिकेशन भरोसे के वर्ष" },
        { v: "4", l: "ग्लोबल प्रिंसिपल पार्टनरशिप" },
        { v: "3", l: "क्रिटिकल-प्रेसिशन इंडस्ट्रीज़" },
        { v: "360°", l: "सर्विस लाइफ़साइकल" },
      ],
    },
    lifecycle: {
      eyebrow: "360° सर्विस लाइफ़साइकल",
      title: "फ़ीज़िबिलिटी स्टडी से पहले सही पार्ट तक।",
      sub: "एक ज़िम्मेदार पार्टनर, विशेषज्ञता के तीन चरण।",
      steps: [
        {
          step: "01",
          title: "प्रीसेल्स फ़ीज़िबिलिटी और एप्लिकेशन इंजीनियरिंग",
          desc: "कंपोनेंट विश्लेषण, CAD समीक्षा, कटिंग-फ़ोर्स कैलकुलेशन और फ़िक्स्चर सिफ़ारिश — खर्च शुरू होने से पहले।",
        },
        {
          step: "02",
          title: "प्रेसिशन प्रोडक्ट सेल्स और सप्लाई",
          desc: "विश्वस्तरीय प्रिंसिपल्स से असली उत्पाद — कैलिब्रेशन सर्टिफ़िकेट, दस्तावेज़ीकरण और तेज़ डिलीवरी के साथ।",
        },
        {
          step: "03",
          title: "पोस्ट-सेल्स इंटीग्रेशन और ट्रेनिंग",
          desc: "ऑन-साइट इंस्टॉलेशन, ज़ीरो-पॉइंट अलाइनमेंट, ऑपरेटर सेफ़्टी और मेंटेनेंस ट्रेनिंग — जब तक आपकी टीम पूरे भरोसे से न चलाए।",
        },
      ],
    },
    brands: {
      eyebrow: "हमारे प्रिंसिपल्स",
      title: "चार विश्वस्तरीय वर्कहोल्डिंग घराने। एक ज़िम्मेदार पार्टनर।",
      productsLabel: "प्रतिनिधित्व रेंज",
      specsLabel: "तकनीकी हाइलाइट्स",
      items: {
        rudra: {
          badge: "10+ वर्षों की पार्टनरशिप",
          tagline: "इलेक्ट्रो-परमानेंट मैग्नेटिक चक और हेवी-ड्यूटी लिफ़्टर",
          desc: "हाई-रिज़िडिटी मिलिंग और सर्फ़ेस ग्राइंडिंग के लिए इलेक्ट्रो-परमानेंट मैग्नेटिक वर्कहोल्डिंग, साथ में हेवी-ड्यूटी लिफ़्टर और कूलेंट सेपरेशन — हमारी सबसे लंबी, 10+ वर्षों की पार्टनरशिप।",
        },
        erowa: {
          badge: "स्विस प्रेसिशन टूलिंग",
          tagline: "ज़ीरो-पॉइंट क्लैंपिंग, EDM टूलिंग और ऑटोमेशन",
          desc: "पूरी EROWA फ़्लेक्सिबल टूलिंग सिस्टम — मानकीकृत ज़ीरो-पॉइंट डेटम (MTS) जो आपके पार्ट को मिलिंग से EDM और इंस्पेक्शन तक सब-माइक्रोन रिपीटेबिलिटी के साथ ले जाता है, साथ में लाइट्स-आउट प्रोडक्शन के लिए रोबोट लोडिंग।",
        },
        spreitzer: {
          badge: "जर्मन क्लैंपिंग टेक्नोलॉजी",
          tagline: "5-एक्सिस, कॉनसेंट्रिक और ALUMESS मॉड्यूलर क्लैंपिंग",
          desc: "पूरी SPREITZER रेंज — 5-एक्सिस एक्सेस के लिए मैकेनिकल और हाइड्रोलिक वाइस, सेल्फ़-सेंटरिंग कॉनसेंट्रिक क्लैंपिंग, और मेज़रमेंट व मशीनिंग के लिए ALUMESS मॉड्यूलर फ़िक्स्चर सिस्टम।",
        },
      },
    },
    industries: {
      eyebrow: "हम जिन इंडस्ट्रीज़ की सेवा करते हैं",
      title: "जहाँ क्लैंपिंग फ़ेल होना मुमकिन नहीं।",
      items: [
        {
          id: "aerospace",
          name: "एयरोस्पेस इक्विपमेंट मैन्युफ़ैक्चरिंग",
          highlight: "ज़ीरो डिस्टॉर्शन के साथ थिन-वॉल क्लैंपिंग",
          desc: "लो-स्ट्रेस मैग्नेटिक और इंजीनियर्ड फ़िक्स्चर — पतली रिब, केसिंग और रिंग को एक माइक्रोन भी बिगाए बिना पकड़ें।",
          stat: "ज़ीरो-डिस्टॉर्शन फ़िक्स्चरिंग",
        },
        {
          id: "defence",
          name: "रक्षा उपकरण निर्माण",
          highlight: "हेवी-ड्यूटी क्लैंपिंग और मैग्नेटिक सिस्टम",
          desc: "आर्मर स्टील, ऑर्डनेंस कंपोनेंट और हेवी प्लेट के लिए फ़ेल-सेफ़ मैग्नेटिक वर्कहोल्डिंग और हाई-फ़ोर्स क्लैंपिंग।",
          stat: "फ़ेल-सेफ़ मैग्नेटिक होल्डिंग",
        },
        {
          id: "diemould",
          name: "डाई एंड मोल्ड इंडस्ट्री",
          highlight: "ज़ीरो-पॉइंट सिस्टम, 5-एक्सिस क्लैंपिंग, इलेक्ट्रोड मशीनिंग",
          desc: "पैलेटाइज़्ड ज़ीरो-पॉइंट डेटम और इलेक्ट्रोड टूलिंग — मिलिंग, EDM और CMM के बीच रिपीटेबिलिटी की गारंटी के साथ।",
          stat: "एक डेटम, हर मशीन",
        },
        {
          id: "precision",
          name: "प्रिसिशन मशीन शॉप्स",
          highlight: "हर लॉट साइज़ के लिए बहुमुखी वर्कहोल्डिंग",
          desc: "वन-ऑफ़ जॉबिंग से वॉल्यूम प्रोडक्शन तक — सेकंडों में चेंजओवर होने वाले मॉड्यूलर वाइस, चक और मैंड्रेल।",
          stat: "तेज़ चेंजओवर फ़िक्स्चर",
        },
      ],
    },
    form: {
      eyebrow: "कोटेशन का अनुरोध करें",
      title: "बताइए आपको क्या पकड़ना है।",
      sub: "अपना कंपोनेंट और एप्लिकेशन साझा करें — हमारे इंजीनियर एक कार्य-दिवस में जवाब देते हैं।",
      contactLabels: { phone: "कॉल करें", email: "ईमेल", visit: "मिलें" },
      labels: {
        name: "पूरा नाम",
        company: "कंपनी",
        email: "ईमेल",
        phone: "फ़ोन",
        brand: "ब्रांड रुचि",
        details: "एप्लिकेशन विवरण",
      },
      placeholders: {
        name: "आपका नाम",
        company: "कंपनी का नाम",
        email: "you@company.com",
        phone: "+91 ...",
        details: "उदा. थिन-वॉल एयरोस्पेस रिब, 6061-T6 एल्यूमीनियम, 3-एक्सिस मिलिंग पर…",
      },
      selectOption: "चुनें…",
      brandOptions: ["Rudra Magnets", "EROWA", "SPREITZER", "एकाधिक / निश्चित नहीं"],
      submit: "पूछताछ भेजें",
      submitting: "भेजा जा रहा है…",
      successTitle: "पूछताछ प्राप्त हुई",
      successBody: "हमारी टीम एक कार्य-दिवस में संपर्क करेगी।",
      errorTitle: "कुछ ग़लत हो गया",
      errorBody: "कृपया दोबारा कोशिश करें या md@teknik.net.in पर ईमेल करें।",
      address: "प्लॉट नं. RH 158, MIDC, डोंबिवली ईस्ट, महाराष्ट्र - 421203, भारत",
    },
    footer: {
      blurb: "हाई-प्रेसिशन वर्कहोल्डिंग, क्लैंपिंग सिस्टम और टूलिंग — बिक्री, प्रीसेल्स इंजीनियरिंग और पोस्ट-सेल्स सपोर्ट।",
      principalsLabel: "प्रिंसिपल्स",
      servicesLabel: "सेवाएँ",
      services: ["सेल्स", "प्रीसेल्स इंजीनियरिंग", "पोस्ट-सेल्स सपोर्ट"],
      rights: "सर्वाधिकार सुरक्षित।",
    },
  },

  /* ------------------------------ मराठी ------------------------------ */
  mr: {
    nav: {
      about: "आमच्याबद्दल",
      lifecycle: "सेवा",
      brands: "ब्रँड्स",
      industries: "उद्योग",
      contact: "संपर्क",
      cta: "कोटेशन मिळवा",
    },
    hero: {
      eyebrow: "प्रिसिशन वर्कहोल्डिंग · डोंबिवली MIDC, भारत",
      titleLines: ["प्रत्येक मायक्रॉन", "घट्ट पकडीत —", "प्रत्येक सायकलमध्ये."],
      sub: "हाय-प्रिसिशन वर्कहोल्डिंग, क्लॅम्पिंग सिस्टीम आणि टूलिंगसाठी विक्री, प्री-सेल्स अभियांत्रिकी आणि पोस्ट-सेल्स सपोर्ट — एका दशकाहून अधिक काळ भारताच्या एरोस्पेस, संरक्षण आणि डाय अँड मोल्ड उद्योगाचा विश्वास.",
      ctaPrimary: "कोटेशन मिळवा",
      ctaSecondary: "आमचे ब्रँड्स",
      badgeLabel: "अ‍ॅप्लिकेशन अभियांत्रिकीचा विश्वासाची वर्षे",
      chips: ["±0.002 mm पुनरावृत्ती", "झिरो-डिस्टॉर्शन क्लॅम्पिंग"],
      scroll: "स्क्रोल",
    },
    marquee: [
      "झिरो-पॉइंट क्लॅम्पिंग",
      "इलेक्ट्रो-परमानेंट मॅग्नेटिक चक",
      "5-अॅक्सिस व्हाइस",
      "क्विक-चेंज कोलेट चक",
      "EDM टूलिंग",
      "अ‍ॅडाप्टिव्ह वर्कहोल्डिंग",
    ],
    about: {
      eyebrow: "आमची ओळख",
      title: "अ‍ॅप्लिकेशन अभियंता मशीनजवळ — फक्त डेस्कवर नाही.",
      p1: "प्लॉट RH 158, MIDC डोंबिवली पूर्व येथून, Teknik Enterprises चार जागतिक दर्जाच्या प्रिन्सिपल्सचे प्रतिनिधित्व करते — मॅग्नेटिक, झिरो-पॉइंट, मेकॅनिकल आणि अ‍ॅडाप्टिव्ह वर्कहोल्डिंगमध्ये. एका दशकाहून अधिक काळ आम्ही भारतीय उत्पादकांना स्मार्ट क्लॅम्पिंगमध्ये मदत करत आहोत — घटक ऑडिट, फोर्स गणना आणि प्रत्येक इन्स्टॉलेशनमागे पूर्ण पाठिंबा.",
      p2: "आम्ही जे सिद्ध करू शकतो तेच विकतो. प्रत्येक शिफारस तुमच्या घटकावरील फिजिबिलिटी स्टडीने सुरू होते आणि चांगले भाग तयार करणाऱ्या मशीनवर समाप्त होते.",
      stats: [
        { v: "10+", l: "अ‍ॅप्लिकेशन विश्वासाची वर्षे" },
        { v: "4", l: "जागतिक प्रिन्सिपल भागीदारी" },
        { v: "3", l: "क्रिटिकल-प्रिसिशन उद्योग" },
        { v: "360°", l: "सर्व्हिस लाइफसायकल" },
      ],
    },
    lifecycle: {
      eyebrow: "360° सर्व्हिस लाइफसायकल",
      title: "फिजिबिलिटी स्टडीपासून पहिल्या चांगल्या भागापर्यंत.",
      sub: "एकच जबाबदार भागीदार, तज्ज्ञतेचे तीन टप्पे.",
      steps: [
        {
          step: "01",
          title: "प्री-सेल्स फिजिबिलिटी आणि अ‍ॅप्लिकेशन अभियांत्रिकी",
          desc: "घटक विश्लेषण, CAD तपासणी, कटिंग-फोर्स गणना आणि फिक्स्चर शिफारस — खर्च सुरू होण्यापूर्वी.",
        },
        {
          step: "02",
          title: "प्रिसिशन प्रॉडक्ट विक्री आणि पुरवठा",
          desc: "जागतिक दर्जाच्या प्रिन्सिपल्सकडून खरी उत्पादने — कॅलिब्रेशन प्रमाणपत्र, डॉक्युमेंटेशन आणि झटपट वितरणासह.",
        },
        {
          step: "03",
          title: "पोस्ट-सेल्स इंटिग्रेशन आणि प्रशिक्षण",
          desc: "ऑन-साइट इन्स्टॉलेशन, झिरो-पॉइंट अलाइनमेंट, ऑपरेटर सेफ्टी आणि देखभाल प्रशिक्षण — तुमची टीम पूर्ण विश्वासाने चालवेपर्यंत.",
        },
      ],
    },
    brands: {
      eyebrow: "आमचे प्रिन्सिपल्स",
      title: "चार जागतिक दर्जाची वर्कहोल्डिंग घरं. एक जबाबदार भागीदार.",
      productsLabel: "प्रतिनिधित्व श्रेणी",
      specsLabel: "तांत्रिक ठळक मुद्दे",
      items: {
        rudra: {
          badge: "10+ वर्षांची भागीदारी",
          tagline: "इलेक्ट्रो-परमानेंट मॅग्नेटिक चक आणि हेव्ही-ड्युटी लिफ्टर",
          desc: "हाय-रिजिडिटी मिलिंग आणि सरफेस ग्राइंडिंगसाठी इलेक्ट्रो-परमानेंट मॅग्नेटिक वर्कहोल्डिंग, त्याचबरोबर हेव्ही-ड्युटी लिफ्टर आणि कूलंट सेपरेशन — आमची सर्वात जुनी, 10+ वर्षांची भागीदारी.",
        },
        erowa: {
          badge: "स्विस प्रिसिशन टूलिंग",
          tagline: "झिरो-पॉइंट क्लॅम्पिंग, EDM टूलिंग आणि ऑटोमेशन",
          desc: "संपूर्ण EROWA फ्लेक्सिबल टूलिंग सिस्टीम — प्रमाणित झिरो-पॉइंट डेटम (MTS) तुमचा भाग मिलिंगपासून EDM आणि तपासणीपर्यंत सब-मायक्रॉन पुनरावृत्तीसह नेतो, त्याचबरोबर लाइट्स-आउट प्रॉडक्शनसाठी रोबोट लोडिंग.",
        },
        spreitzer: {
          badge: "जर्मन क्लॅम्पिंग टेक्नॉलॉजी",
          tagline: "5-अॅक्सिस, कॉन्सेन्ट्रिक आणि ALUMESS मॉड्यूलर क्लॅम्पिंग",
          desc: "संपूर्ण SPREITZER श्रेणी — 5-अॅक्सिस प्रवेशासाठी मेकॅनिकल आणि हायड्रॉलिक व्हाइस, सेल्फ-सेंटरिंग कॉन्सेन्ट्रिक क्लॅम्पिंग, आणि मापन व मशीनिंगसाठी ALUMESS मॉड्यूलर फिक्स्चर सिस्टीम.",
        },
      },
    },
    industries: {
      eyebrow: "आम्ही सेवा देत असलेले उद्योग",
      title: "जिथे क्लॅम्पिंग अपयश नाही चालत.",
      items: [
        {
          id: "aerospace",
          name: "एरोस्पेस उपकरण निर्मिती",
          highlight: "झिरो डिस्टॉर्शनसह थिन-वॉल क्लॅम्पिंग",
          desc: "लो-स्ट्रेस मॅग्नेटिक आणि अभियांत्रिक फिक्स्चर — पातळ रिब, केसिंग आणि रिंग एकही मायक्रॉन विकृत न करता धरतात.",
          stat: "झिरो-डिस्टॉर्शन फिक्स्चरिंग",
        },
        {
          id: "defence",
          name: "संरक्षण उपकरण निर्मिती",
          highlight: "हेव्ही-ड्युटी क्लॅम्पिंग आणि मॅग्नेटिक सिस्टीम",
          desc: "आर्मर स्टील, ऑर्डनन्स घटक आणि जड प्लेटसाठी फेल-सेफ मॅग्नेटिक वर्कहोल्डिंग आणि हाय-फोर्स क्लॅम्पिंग.",
          stat: "फेल-सेफ मॅग्नेटिक होल्डिंग",
        },
        {
          id: "diemould",
          name: "डाय अँड मोल्ड उद्योग",
          highlight: "झिरो-पॉइंट सिस्टीम, 5-अॅक्सिस क्लॅम्पिंग, इलेक्ट्रोड मशीनिंग",
          desc: "पॅलेटाइज्ड झिरो-पॉइंट डेटम आणि इलेक्ट्रोड टूलिंग — मिलिंग, EDM आणि CMM दरम्यान पुनरावृत्तीची हमी.",
          stat: "एक डेटम, प्रत्येक मशीन",
        },
        {
          id: "precision",
          name: "प्रिसिशन मशीन शॉप्स",
          highlight: "प्रत्येक लॉट साइझसाठी बहुमुखी वर्कहोल्डिंग",
          desc: "वन-ऑफ जॉबिंगपासून व्हॉल्यूम उत्पादनापर्यंत — सेकंदांत बदलणारे मॉड्यूलर व्हाइस, चक आणि मँड्रेल.",
          stat: "जलद बदल फिक्स्चर",
        },
      ],
    },
    form: {
      eyebrow: "कोटेशनसाठी विचारा",
      title: "काय धरून ठेवायचे आहे ते सांगा.",
      sub: "तुमचा घटक आणि अ‍ॅप्लिकेशन सामायिक करा — आमचे अभियंता एका कार्य-दिवसात प्रत्युत्तर देतात.",
      contactLabels: { phone: "कॉल करा", email: "ईमेल", visit: "भेट द्या" },
      labels: {
        name: "पूर्ण नाव",
        company: "कंपनी",
        email: "ईमेल",
        phone: "फोन",
        brand: "ब्रँड स्वारसी",
        details: "अ‍ॅप्लिकेशन तपशील",
      },
      placeholders: {
        name: "तुमचे नाव",
        company: "कंपनीचे नाव",
        email: "you@company.com",
        phone: "+91 ...",
        details: "उदा. थिन-वॉल एरोस्पेस रिब, 6061-T6 ॲल्युमिनियम, 3-अॅक्सिस मिलिंगवर…",
      },
      selectOption: "निवडा…",
      brandOptions: ["Rudra Magnets", "EROWA", "SPREITZER", "एकाधिक / खात्री नाही"],
      submit: "चौकशी पाठवा",
      submitting: "पाठवत आहे…",
      successTitle: "चौकशी मिळाली",
      successBody: "आमची टीम एका कार्य-दिवसात संपर्क करेल.",
      errorTitle: "काहीतरी चूक झाली",
      errorBody: "कृपया पुन्हा प्रयत्न करा किंवा md@teknik.net.in या ईमेल करा.",
      address: "प्लॉट नं. RH 158, MIDC, डोंबिवली पूर्व, महाराष्ट्र - 421203, भारत",
    },
    footer: {
      blurb: "हाय-प्रिसिशन वर्कहोल्डिंग, क्लॅम्पिंग सिस्टीम आणि टूलिंग — विक्री, प्री-सेल्स अभियांत्रिकी आणि पोस्ट-सेल्स सपोर्ट.",
      principalsLabel: "प्रिन्सिपल्स",
      servicesLabel: "सेवा",
      services: ["विक्री", "प्री-सेल्स अभियांत्रिकी", "पोस्ट-सेल्स सपोर्ट"],
      rights: "सर्व हक्क राखीव.",
    },
  },
};
